import React from 'react';

import { Container } from './styles';

const Logo: React.FC = () => {
  return (
    <Container>
      <img src="/assets/evento/logo.png" />
    </Container>
  );
};
export default Logo;
